import { useCurrentAudioTrack } from '@/scenarios/legacy-player/hooks/useCurrentAudioTrack';
import { useInstanceCallback } from '@/scenarios/legacy-player/hooks/useInstanceCallback';
import { AudioTrack, TextTrack } from '@/scenarios/legacy-player/types/instance';

export const useSelectTrack = (contentId: string) => {
    const currentAudioTrack = useCurrentAudioTrack();
    const audioLanguage = currentAudioTrack?.lang;

    const onAudioLangChange = useInstanceCallback(
        (instance, newTrack: AudioTrack) => {
            if (newTrack) {
                instance?.setAudioTrack(newTrack);
            }
        },
        [contentId]
    );

    const onSubtitlesLangChange = useInstanceCallback(
        (instance, newTrack: TextTrack) => {
            if (audioLanguage) {
                instance?.setTextTrack(newTrack);
            }
        },
        [audioLanguage]
    );

    return { onAudioLangChange, onSubtitlesLangChange };
};
